import React from 'react'
import ProjectCards from './ProjectCards'
import ProjectHero from './ProjectHero'

const Project = () => {
  return (
    <div>
      <ProjectHero/>
        <ProjectCards/>
    </div>
  )
}

export default Project